import { Link, useLoaderData } from "react-router-dom";
import ServerFooter from "src/components/common/ServerFooter";
import { form } from "../types";
/* ---------------- types ---------------- */
export default function FormList(){
    const { forms, total } =
    useLoaderData() as {
        forms: form[];
        total: number;
    };
    return (
        <div className = {"cssContent" + (total > 0?" pb8rem":"")}>
            <h3>Forms</h3>
            <div className = "mb-2">
                <Link
                    children = "Create"
                    to = "Create"
                    className = "btn btn-outline-primary"
                />
                <Link
                    children = "Back"
                    to = ".."
                    className = "btn btn-outline-secondary float-end"
                />
            </div>
            {total === 0 ? <div children = "No forms yet." className = "alert alert-info text-center"/>:
            <table className="table">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {forms.map(form => (
                    <tr key = {form.id}>
                        <td>{form.name}</td>
                        <td>{form.type}</td>
                        <td>{form.status}</td>
                        <td>
                            <Link
                                children = "Detail"
                                to = {String(form.id)}
                                className = "btn btn-outline-primary"
                            />
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>}
            {total>0?<ServerFooter length = {total}/>:null}
        </div>
    );
}